import { Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs';
import { Helper } from '../../../shared/helpers/helper';
import { Router } from '@angular/router';
import { User } from '../../../shared/models/user.model';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { forEach, filter, some, orderBy } from 'lodash';
import { CompareWellsService } from '../../../shared/services/compare-wells.service';
import { WellListTableComponent } from '../well-list-table/well-list-table.component';
import { WellsCompareDataService, IWellsCompareInputData } from '../wells-compare-data.service';
import { ModalConfirmComponent } from '../../../shared/components/modals/confirm/modal-confirm.component';
import { NbDialogService } from '@nebular/theme';
import { UserRolesService } from '../../../shared/services/user-roles.service';
import { LoadingOverlayService } from '../../../shared/services/loading-overlay.service';
import { SortEvent } from '../../../shared/directives/sortable-table-header.directive';
// import { tileLayer, latLng, marker, polygon, circle, Layer, Map, icon } from 'leaflet';

@Component({
  selector: 'app-well-list',
  templateUrl: './well-list.component.html',
  styleUrls: ['./well-list.component.scss']
})
export class WellListComponent implements OnInit, OnDestroy {

  @ViewChild(WellListTableComponent) wellTable: WellListTableComponent;
  subscriptions: Subscription[] = [];
  loading: boolean = false;
  // Compare
  compareData: any;

  // Delete
  isCarboAdmin: boolean = false;
  isDisabledCompare: boolean = false;

  isService: boolean = false;
  isOperator: boolean = false;
  // Paging
  pagingState = {
    page: 1,
    pageSize: 20,
    collectionSize: 10
  };
  sortState = {
    sortField: '',
    sortType: false
  };

  // Compare Type
  compareType: string = 'Single Wells';

  // Treatment
  treatment: any[] = [];
  treatmentMultiList: any[] = [];

  // Channel
  channel: any[] = [];

  // Parameter
  parameter: any[] = [];

  user: User;

  listWells: any[] = [];
  selectedListWells: any[] = [];
  countWells: number;

  searchFormValues: any;

  // mapInstance: Map;
  // leafletOptions = {
  //   layers: [
  //     tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '...' })
  //   ],
  //   zoom: 3,
  //   center: latLng(31.169621, -99.683617)
  // };

  // layerMarkers: Layer[] = [];

  constructor(
    private router: Router,
    private userAuthService: UserAuthService,
    private userRolesService: UserRolesService,
    private compareWellsService: CompareWellsService,
    private dialogService: NbDialogService,
    private wellsCompareDataService: WellsCompareDataService,
    private loadingOverlayService: LoadingOverlayService
  ) {

  }

  ngOnInit() {
    this.user = this.userAuthService.getUserInfo();
    const userRole = this.userRolesService.toUserRole(this.user);
    this.isCarboAdmin = this.userRolesService.isCarboAdmin(userRole);
    if (this.user && this.user.companyType !== 'Service') {
      this.isService = true;
    }
    if (this.user && this.user.companyType !== 'Operator') {
      this.isOperator = true;
    }
    this.loadData();
  }

  ngOnDestroy(): void {
    Helper.unsubscribe(this.subscriptions);
  }

  wellDetails(item: any) {
    //this.router.navigate(['pages', 'wells', `${item.wellId}`]);
    this.router.navigate(['pages', 'wells', `${item.wellId}`], {
      queryParams: {
        page: this.pagingState.page
      }
    });
  }

  selectedWellsChange(event) {
    if (event && event.selected) {
      const items = filter(event.selected, {selected: true});
      const isNoTreatmentData = some(items, (i: any) => {
        return !(i.treatmentList && i.treatmentList.length > 0);
      });
      this.selectedListWells = items;
      this.countWells = items.length;
      // Disabled compare if well hasn't treatment data
      this.isDisabledCompare = isNoTreatmentData ? true : false;
    }
    if (this.countWells > 1) {
      this.compareType = 'Multiple Wells';
    } else if (this.countWells === 1) {
      this.compareType = 'Single Wells';
    }
    // this.getListCompare();
  }
  loadData() {
    this.loading = true;
    this.subscriptions.push(
      this.compareWellsService.getListWell(
        this.searchFormValues, this.pagingState.page, this.pagingState.pageSize, this.sortState.sortField, this.sortState.sortType
      ).subscribe(
      (res) => {
        if (res) {
          forEach(res.result.items,  item => {
            // Sort treatment by treatment number
            item.treatmentList = orderBy(item.treatmentList, i => i.treatmentNumber);
            item.treatmentIdDefault = item.treatmentList.length > 0 ? item.treatmentList[0].id : null;
          });
          const listWells = res.result.items;
          this.listWells = forEach(listWells, item => {
            if (some(this.selectedListWells, {wellId: item.wellId})) {
              item.selected = true;
            } else {
              item.selected = false;
            }
          });
          // Disabled compare if well hasn't treatment data
          const isNoTreatmentData = some(this.selectedListWells, (i: any) => {
            return !(i.treatmentList && i.treatmentList.length > 0);
          });
          this.isDisabledCompare = isNoTreatmentData ? true : false;
          this.pagingState.collectionSize = res.result.totalCount;
        }
        this.loading = false;
      }, (error) => {
        this.loading = false;
      }
    ));
  }

  onSearchWells(eventData) {
    this.pagingState.page = 1;
    this.searchFormValues = eventData;
    this.loadData();
  }

  onSortWells(eventData: SortEvent) {
    if (eventData) {
      this.sortState.sortField = eventData.column;
      this.sortState.sortType = eventData.direction === 'asc';
      this.loadData();
    }
  }

  submitCompare() {
    const compareData: IWellsCompareInputData = {
      compareType: this.compareType,
      parameterSelect: this.parameter,
      channelSelect: this.channel,
      treatmentSelect: this.treatment,
      wellSelect: this.selectedListWells,
    };
    this.wellsCompareDataService.setInputData(compareData);
    this.router.navigate(['pages', 'wells', 'compare']);
  }

  onCancel() {
    this.compareData = null;
    this.countWells = 0;
    this.selectedListWells = [];
    this.wellTable.removeAllSelected();
    this.loadData();
  }

  onDeleteWells(data) {
    this.loadingOverlayService.show();
    const param = data.map(item => {
      return item.wellId;
    });
    this.subscriptions.push(
      this.compareWellsService.deleteWells(param, () => {
          this.loadingOverlayService.hide();
        }).subscribe(
        (res) => {
          this.selectedListWells = [];
          this.countWells = 0;
          this.wellTable.removeAllSelected();
          this.loadData();
        }
      )
    );
  }

  onDeleteConfirm(selectedWells): void {
    let wellName = 'Well Operation';
    if (selectedWells && selectedWells.length > 0) {
      const allWellNames = selectedWells.map(item => item.wellName);
      wellName = `<b>${allWellNames.join(', ')}</b>`;
    }
    this.dialogService.open(ModalConfirmComponent, {
      context: {config: {
        title: 'Delete',
        message: `Delete ${wellName} will permanently delete Well data. Are you sure you want to continue?`,
        className: 'pop-delete common-page',
        btnTxtConfirm: 'Yes',
        btnTxtCancel: 'No',
        data: selectedWells,
      }}
    }).onClose.subscribe(res => {
      if (res && res.confirm) {
        this.onDeleteWells(res.data);
      }
    });
  }

  dataTable(page) {
    this.pagingState.page = page;
    this.loadData();
  }

  // onMapReady(map: Map) {
  //   this.mapInstance = map;
  // }
}
